import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import axios from "axios";
import moment from "moment";
import $ from "jquery";
import "daterangepicker/daterangepicker.css";
import "daterangepicker";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const ViewPaymentPlanJathagam = () => {
  // Set both startDate and endDate to today
  const today = moment().format("YYYY-MM-DD");
  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(today);
  const [payments, setPayments] = useState([]);
  const [search, setSearch] = useState("");
  const [filteredPayments, setFilteredPayments] = useState([]);

  useEffect(() => {
    fetchPayments();
  }, []);

  // Initialize the date range picker once when the component mounts
  useEffect(() => {
    $("#dateRangePicker").daterangepicker(
      {
        startDate: moment(startDate),
        endDate: moment(endDate),
        ranges: {
          Today: [moment(), moment()],
          Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
          "Last 7 Days": [moment().subtract(6, "days"), moment()],
          "Last 30 Days": [moment().subtract(29, "days"), moment()],
        },
      },
      (start, end) => {
        const newStart = start.format("YYYY-MM-DD");
        const newEnd = end.format("YYYY-MM-DD");
        setStartDate(newStart);
        setEndDate(newEnd);
        applyFilters(search, start, end);
        // Update display text based on selected range
        if (newStart === newEnd) {
          $("#dateRangePicker").html(start.format("MMMM D, YYYY"));
        } else {
          $("#dateRangePicker").html(`${start.format("MMMM D, YYYY")} - ${end.format("MMMM D, YYYY")}`);
        }
      }
    );

    // Set the initial display text to today's date
    $("#dateRangePicker").html(moment(today).format("MMMM D, YYYY"));
  }, []);

  // Reapply filters when payments, search, or the date range change
  useEffect(() => {
    applyFilters(search, moment(startDate), moment(endDate));
  }, [payments, search, startDate, endDate]);

  const fetchPayments = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/get_payment_jathagam`);
      setPayments(response.data);
      setFilteredPayments(response.data); // Initially show all records
    } catch (error) {
      console.error("Error fetching payments", error);
    }
  };

  // Filter payments by search text and date range
  const applyFilters = (searchText, start, end) => {
    const filteredData = payments
      .filter((payment) => {
        const txnDate = moment(payment.TXN_DATE);
        // Check if the payment date is within the selected range (inclusive)
        const isWithinRange = txnDate.isBetween(start, end, undefined, "[]");

        // Check search text against name, mobile, or invoice number
        const matchesSearch =
          payment.name.toLowerCase().includes(searchText.toLowerCase()) ||
          payment.mobile.includes(searchText) ||
          payment.inv_no.includes(searchText);

        return isWithinRange && matchesSearch;
      })
      .map((payment, index) => ({ ...payment, sNo: index + 1 }));
    setFilteredPayments(filteredData);
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
    applyFilters(e.target.value, moment(startDate), moment(endDate));
  };

  const handleViewProof = (proofUrl) => {
    if (proofUrl) {
      window.open(proofUrl, "_blank");
    } else {
      alert("Payment proof not available.");
    }
  };

  const handleViewInvoice = (invoiceUrl) => {
    if (invoiceUrl) {
      window.open(invoiceUrl, "_blank");
    } else {
      alert("Invoice PDF not available.");
    }
  };

  const columns = [
    { name: "S.No", selector: (row) => row.sNo, sortable: false, width: "70px" },    
    { name: "Name", selector: (row) => row.name, sortable: true },
    { name: "Mobile No", selector: (row) => row.mobile, sortable: true },
    { name: "Payment Mode", selector: (row) => row.payment_mode, sortable: true },
    { name: "Transaction No", selector: (row) => row.TXN_ID, sortable: true },
    { name: "Transaction Date", selector: (row) => row.TXN_DATE, sortable: true },
    { name: 'Status', selector: (row) => row.TXN_STATUS},
    { name: "Amount", selector: (row) => `₹${row.TXN_AMOUNT}`, sortable: true },
    { name: "Add By", selector: (row) => row.cby },
    {
      name: "Remarks",
      cell: (row) => {
        const maxLength = 50;
        const isLong = row.payment_remark?.length > maxLength;
        const shortText = row.payment_remark?.substring(0, maxLength);
        return (
          <div style={{ maxWidth: "300px", whiteSpace: "normal" }}>
            {isLong ? (
              <span>
                {shortText}...
                <span
                  onClick={() => alert(`Full Remark:\n\n${row.payment_remark}`)}
                  style={{ color: "blue", cursor: "pointer", marginLeft: "5px", textDecoration: "underline" }}
                >
                  Read more
                </span>
              </span>
            ) : (
              row.payment_remark
            )}
          </div>
        );
      },
      sortable: false,
    },
    

    {
      name: "PAYMENT PROOF",
      cell: (row) => (
        <button
          onClick={() => handleViewProof(row.payment_proof)}
          style={{
            backgroundColor: "blue",
            color: "white",
            border: "none",
            padding: "2px 9px",
            cursor: "pointer",
          }}
        >
          Payment Proof
        </button>
      ),
    },
    {
      name: "INVOICE",
      cell: (row) => (
        <button
          onClick={() => handleViewInvoice(row.invoice_path)}
          style={{
            backgroundColor: "red",
            color: "white",
            border: "none",
            padding: "2px 9px",
            cursor: "pointer",
          }}
        >
          View Invoice
        </button>
      ),
    },
  ];

  return (
    <div className="bg-gray-100 p-6">
      <div className="max-w-7xl mx-auto bg-white shadow-lg rounded-lg p-6">
        <h1 className="text-2xl font-semibold mb-4 text-blue-700 text-center">
          Jathagam Payment Report
        </h1>
        <div className="flex justify-center mb-4">
          <input
            type="text"
            placeholder="Search by Name, Mobile, or Invoice No"
            value={search}
            onChange={handleSearch}
            className="border border-gray-300 rounded-md p-2 w-1/3"
          />
        </div>
        <div className="mb-4 text-center">
          <label className="mr-3 font-bold">Filter by Date:</label>
          {/* Date range picker container */}
          <div
            id="dateRangePicker"
            className="inline-block p-2 border rounded cursor-pointer"
          >
            {startDate === endDate
              ? moment(startDate).format("MMMM D, YYYY")
              : `${moment(startDate).format("MMMM D, YYYY")} - ${moment(endDate).format("MMMM D, YYYY")}`}
          </div>
        </div>
        <DataTable
          columns={columns}
          data={filteredPayments}
          pagination
          highlightOnHover
          striped
          persistTableHead
        />
      </div>
    </div>
  );
};

export default ViewPaymentPlanJathagam;


